import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FleetChecklistNavigationService {

  constructor(
    private router: Router
  ) { }

  openChecklist(fleetId : string) {
     const url = this.router.serializeUrl(
      this.router.createUrlTree(['/validation',fleetId])
    );
    window.open(url, '_blank');
  }

}
